import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridOpenMarkShippedModal } from '../../../store/orders/grid/orders.grid.header.actions';
import { BASE_MAS_PAGE } from '../../../orders/mark-as-shipped/constants';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { useContainsDemoOrder } from '../../../demos/hooks/use-contains-demo-order';
import { messages } from './messages';

export const useMarkShipped = () => {
  const dispatch = useDispatch();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();
  const hasDemoOrder = useContainsDemoOrder();
  const disabledReason = useMemo(() => {
    return hasDemoOrder ? messages.isDemoDisabledMessage : null;
  }, [hasDemoOrder]);
  const shouldBeDisabled = hasDemoOrder || oneOrMoreOrderSelectedDisabled;
  const actionHandler = useCallback(() => {
    dispatch(orderGridOpenMarkShippedModal(BASE_MAS_PAGE));
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsMarkShipped,
      isDisabled: shouldBeDisabled,
      disabledReason,
    };
  }, [actionHandler, disabledReason, shouldBeDisabled]);
};
